/* @flow */

import { type ParamEntrega, type Retorno } from './types';
import getEntregadoresId from './get-entregadores-id-popover';
import isLoggi from './is-loggi';
import { ETAPA_ENTREGA } from '../constants';
import swalAlterarEtapa from './swalAlterarEtapa';
import getHtmlSelecaoEntrega from './getHtmlSelecaoEntrega';
import onOpenAlterarEtapaEntrega from './onOpenAlterarEtapaEntrega';
import preConfirmAlterarEtapaEntrega from './preConfirmAlterarEtapaEntrega';


const swalAlterarEtapaEntrega = (options: ParamEntrega): Promise<Retorno> => (
    swalAlterarEtapa(ETAPA_ENTREGA, {
        html: getHtmlSelecaoEntrega(options),
        onOpen: onOpenAlterarEtapaEntrega,
        preConfirm: preConfirmAlterarEtapaEntrega,
    })
        .then(() => ({
            isLoggi: isLoggi(),
            entregadoresId: getEntregadoresId(options.entregadores) || undefined,
        }))
);

export default swalAlterarEtapaEntrega;
